interface EnvConfig {
  apiBaseUrl: string;
}


export const config: EnvConfig = {
  apiBaseUrl: process.env.REACT_APP_BASE_URL || "http://localhost:4000",
};
